import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'

const Homes = () => {
    useEffect(() =>{
        document.title = "Earth VIII Homes"
    },[])

    const [RotateDg, setRotateDg] = useState()  

    const rotateDgCSS = {
        transform: "rotate(-25deg)",
        transition: "transform 0.2s ease 0s"
      }

      const removerotateDgCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.2s ease 0s"
      }

      const rotatedg = () =>{
        setRotateDg(rotateDgCSS) 
    }
    const stoprotatedg = () =>{
        setRotateDg(removerotateDgCSS) 
    }

      
      
    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>


<div class="col-md-12 homesfirstbox">
<div class="container">
    <h1 className="homesherotitle"><span className="makeyellow"> Building</span> smart homes. <br/>
        to last. <span className="makeyellow">  Building</span> lasting<br/>
        memories
    </h1>
    
{/* <div class="col-md-5"> */}
<p className="homesherosubtitle fordesktoponly">We build smart homes so that you can enjoy quality living in <br/>
    the Peace of your own home with your family, and to create  <br/>the best
     environment for your kids to thrive.  <br/>We are building for you.</p>

     <p className="homesherosubtitle formobileonly">We build smart homes so that you can enjoy quality living in 
    the Peace of your own home with  your family, and to create the best
     environment for your kids to thrive. We are building for you.</p>
{/* </div> */}
 
 

     <p className="homesheroctabuttonp" >
<Nav.Link className="homesheroctabutton "  href="#explorehomes"><button className="hmfirstboxbutton3">Explore homes</button></Nav.Link>
        {/* <Nav.Link className="homesheroctabutton  homesctabutton2"  href="/homes"><p>Contact us  <img className="" src="images/diagonalarrow.png"/></p></Nav.Link> */}
</p>
</div>
</div>

<div class="col-md-12" id="explorehomes">
    <h1 className="homessecondboxtitle">Our Homes</h1>
    </div>

    <div className='homessecondbox'>
    <div className='container'>
       <div class="row">
           <div class="col-md-5">
               <div class="row">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/blackline.png"/>

                       </div>
                       <div class="col-md-11 col-10">
                       <h2 className="stepdown hmsecondboxtitle" style={{paddingLeft:"25px" }}> Oak Grandeur I</h2>
                       {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                       </div>
                   

               </div>
               <img className="img-fluid hmsecondbox2 formobileonly" src="images/OAK Grandeur 1.jpg"/>

            <p className="hmseconddescription">
            Oak-Grandeur 1 is a residential, luxurious, modern, state of the art, tastefully finished six units of three-bedroom edifice, sitting on 1,100 sq.m, located in the heart of Dawaki, Abuja FCT. It is accessorized with ample interlocked parking space, hut area with games, security, constant water supply and a serene and secure neighbourhood.                
                </p>
        
                <a className="linkdecoration" target="_blank" href="/homes">  <p style={{color:"#4D4D4D"}} className="homeslearnmorecta">Sold Out </p></a>
       <hr className='vohlm'/>
           </div>
           <div class="col-md-1"></div>
           <div class="col-md-6">
           <img className="img-fluid fordesktoponly" src="images/OAK Grandeur 1.jpg"/>
           </div>
       </div>
        </div>
    </div>
    <div className='fordesktoponly'>
<p className='addspacing100'></p>
</div>

 
    <div className='homessecondbox'>
    <div className='container'>
       <div class="row">
           <div class="col-md-5">
               <div class="row">
                   <div class="col-md-1 col-2">
                       {/* <h2  className="line hmsecondboxtitle"></h2> */}
                       <img style={{paddingTop:"34px" }} className="" src="images/blackline.png"/>

                       </div>
                       <div class="col-md-11 col-10">
                       <h2 className="stepdown hmsecondboxtitle" style={{paddingLeft:"25px" }}> Oak Grandeur II</h2>
                       {/* <h2 className=" hmsecondboxtitle formobileonly">  Let us tell you a bit about us</h2> */}

                       </div>
                   

               </div>
               <img className="img-fluid hmsecondbox2 formobileonly" src="images/OAK Grandeur II.jpg"/>

            <p className="hmseconddescription">

            Oak-Grandeur II is an exclusive, beautiful and serene apartment, built on 650sqm area of land and located in a secure and developed area of Jahi-Abuja. The distance from this location to Central area of Abuja is approximately 10 Minutes, with diplomats, middle income earners and business executives as residents of the surrounding area.             
                </p>
        
                <a className="linkdecoration" target="_blank" href="/oakgrandeurii">  <p onMouseEnter={rotatedg} onMouseLeave={stoprotatedg}   className="homeslearnmorecta ">Learn more <img className=""  style={RotateDg}   src="images/rightarrow.png"/></p></a>
       <hr className='vohlm'/>
           </div>
           <div class="col-md-1"></div>
           <div class="col-md-6">
           <img className="img-fluid fordesktoponly" src="images/OAK Grandeur II.jpg"/>
           </div>
       </div>
        </div>
    </div>

    <div className='fordesktoponly'>
<p className='addspacing100'></p>
</div>



<Testimonials/>
<div className='fordesktoponly'>
<p style={{marginTop:"150px"}}></p>
</div>


{/* <br/>
    <br/>
    <br/>
    <br/>
    <br/> */}
    
    <Faq/>
    {/* <br/> */}
    {/* <br/>
    <br/>
    <br/> */}



<div className='formobileonly'>
<p style={{marginTop:"70px", marginBottom:"70px"}}></p>
</div>


<Contact/>








    </div>






    <Footer/>
    </div>


    )
    
    
}


export {Homes as default}